import FileSaver from "file-saver";
import moment from 'moment';
import * as JSZip from 'jszip';
import { sucessNotify } from "../../../services/toast.notification";

const DownloadPdfFile=(ArrayofPdf:any,fileName:string) => {
    var timeInMs = Date.now();
    let MiladiFormat = moment(timeInMs).locale("en").format("YYYY/MM/DD");
    let ShamsiFormat = moment(MiladiFormat).locale("fa").format("YYYY/MM/DD");
    let zip: JSZip = new (<any>JSZip).default();

    var pdf:any = zip.folder(fileName);

    ArrayofPdf.forEach((value:any, i:any) => {
      pdf.file("file"+i.toString() + ".pdf", value, { base64: true });
    });
    
    zip.generateAsync({ type: "blob" }).then(function (content:any) {
      FileSaver.saveAs(content, fileName + ShamsiFormat + ".zip");
      sucessNotify("فایل خروجی با موفقیت ساخته شد");
    });
  }

  export default DownloadPdfFile;